import { render, staticRenderFns } from "./reSignContract.vue?vue&type=template&id=473d669e&"
import script from "./reSignContract.vue?vue&type=script&lang=js&"
export * from "./reSignContract.vue?vue&type=script&lang=js&"
import style0 from "./reSignContract.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports